/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import TableLineIcons from "../../components/TableLineIcons";
import GenericModal from "../../components/GenericModal";
import { Button, Form, Icon, Input, InputNumber, message, Modal, Tooltip } from "antd";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class SelfServiceTexts extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalCreateEdit: null,
            filters: { _posList: "", _langId: null },
            filtersModal: false,
        };

        this.id = "SELF_SERVICE_TEXTS";

        this.api = {
            get: "get_self_service_texts",
            create: "create_self_service_texts",
            edit: "edit_self_service_texts",
            delete: "delete_self_service_texts",
            check: "check_self_service_texts",
        }

        this.selectors = [
            { id: "SELF_SERVICE_LANGS_LIST", api: "self_service_langs_list" },
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach((x) => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21718);
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
    }

    renderEdit = (text, record) => {
        let gt = this.getText;
        return (<TableLineIcons
            onEdit={() => { this.setState({ modalCreateEdit: record }) }}
            onDelete={() => { this.props.dataActions.genericDataDeleteRow(this.id, record.key, this.props.user.companyCode, this.props.user.token, this.api.delete, this.api.get) }}
            deleteQuetion={{ title: gt(21725), okText: gt(21726), cancelText: gt(21727) }}
        />)
    }

    handleOk = () => {
        const data = this.state.modalCreateEdit
        const gt = this.getText
        const saveRow = d => {
            this.sendAPI(d.tID == 0 ? this.api.create : this.api.edit, d, () => {
                message.success(gt(21731))
                this.setState({ modalCreateEdit: null }, this.refreshData)
            })
        }

        if (data.tID == 0) {
            this.sendAPI(this.api.check, data, (ob) => {
                if (ob.data) {
                    const [_id, _text] = ob.data.split("\f")
                    Modal.confirm({
                        content: (<>
                            <h4>{gt(21732)} {data.tTextCode} {gt(21733)} {data.tLangName} {gt(21734)} {data.tPosName} {gt(21735)} {_text}</h4>
                            <h4>{gt(21736)}</h4>
                        </>),
                        iconType: 'exclamation-circle',
                        okText: gt(21737),
                        cancelText: gt(21738),
                        onOk: () => { saveRow({ ...data, tID: _id }) },
                        onCancel() { },
                    })
                } else {
                    saveRow(data)
                }
            })
        } else {
            saveRow(data)
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    handleCopy = () => {
        const { modalCopyFromPos, modalCopyToPos } = this.state
        if (!modalCopyFromPos || !modalCopyToPos) {
            message.error(this.getText(21896))
        } else if (modalCopyToPos.split(",").find(f => f == modalCopyFromPos)) {
            message.error(this.getText(21897))
        } else {
            this.sendAPI("copy_self_service_texts", { modalCopyFromPos, modalCopyToPos }, () => {
                this.setState({ modalCopy: false }, this.refreshData)
            })
        }
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
        };

        let sorter = true;
        let render = t => t;

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                filters={this.state.filters}
                title={gt(21718)}
                addButton={() => {
                    this.setState({
                        modalCreateEdit: {
                            tID: 0,
                            tLangCode: null,
                            tLangName: null,
                            tLangFlag: null,
                            tTextCode: null,
                            tDesc: null,
                            tText: null,
                            tPosID: null,
                            tPosName: null,
                        }
                    })
                }}
                filterButton={() => { this.setState({ filtersModal: true }) }}
                searchBox
                columns={[
                    { title: gt(21719), key: "tLangCode", dataIndex: "tLangCode", width: "15%", sorter, render: (t, r) => `${t} - ${r.tLangName}` },
                    { title: gt(21720), key: "tTextCode", dataIndex: "tTextCode", width: "10%", sorter, render },
                    { title: gt(21721), key: "tDesc", dataIndex: "tDesc", width: "30%", sorter, render },
                    { title: gt(21722), key: "tText", dataIndex: "tText", width: "20%", sorter, render },
                    { title: gt(21723), key: "tPosID", dataIndex: "tPosID", width: "15%", sorter, render: (t, r) => `${t} - ${r.tPosName}` },
                    { title: gt(21724), width: "10%", sorter, render: this.renderEdit },
                ]}
                genericActionButtons={[
                    <Tooltip title={gt(21891)}>
                        <Button className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                            this.setState({ modalCopy: true })
                        }}>
                            <Icon type={"copy"} style={{ fontSize: 16 }} theme={"filled"} />
                        </Button>
                    </Tooltip>
                ]}
            />
            <GenericModal
                visible={this.state.modalCopy}
                onCancel={() => { this.setState({ modalCopy: false }) }}
                title={gt(21891)}
                width={600}
                footer={[
                    <Button key="back" style={{ marginLeft: 5 }} onClick={() => { this.setState({ modalCopy: false }) }}>{gt(21893)}</Button>,
                    <Button key="create" type="primary" onClick={this.handleCopy}>{gt(21892)}</Button>,
                ]}
            >
                <Form.Item label={gt(21894)}>
                    <GenericSelectorPosStorages
                        {...this.props}
                        value={this.state.modalCopyFromPos}
                        onChange={e => { this.setState({ modalCopyFromPos: e }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21895)}>
                    <GenericSelectorPosStorages
                        {...this.props}
                        multi
                        notApi
                        value={this.state.modalCopyToPos ? this.state.modalCopyToPos.split(",") : []}
                        onChange={e => { this.setState({ modalCopyToPos: e ? e.join(",") : "" }) }}
                    />
                </Form.Item>
            </GenericModal>
            <GenericModal
                visible={this.state.modalCreateEdit != null}
                onCancel={() => { this.setState({ modalCreateEdit: null }) }}
                title={gt(21728)}
                width={600}
                footer={[
                    <Button key="back" style={{ marginLeft: 5 }} onClick={() => { this.setState({ modalCreateEdit: null }) }}>{gt(21730)}</Button>,
                    <Button key="create" type="primary" onClick={this.handleOk}>{gt(21729)}</Button>,
                ]}
            >
                <Form.Item label={gt(21719)}>
                    <GenericSelector
                        {...this.props}
                        {...this.selectors[0]}
                        value={this.state.modalCreateEdit?.tLangCode}
                        onChange={() => { }}
                        onChangeGetDetailed={(e) => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tLangCode: e.code, tLangName: e.name } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21720)}>
                    <InputNumber
                        style={{ width: 150 }}
                        value={this.state.modalCreateEdit?.tTextCode}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tTextCode: e } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21722)}>
                    <Input
                        value={this.state.modalCreateEdit?.tText}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tText: e.target.value } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21721)}>
                    <Input.TextArea
                        value={this.state.modalCreateEdit?.tDesc}
                        onChange={e => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tDesc: e.target.value } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(21723)}>
                    <GenericSelectorPosStorages
                        {...this.props}
                        value={this.state.modalCreateEdit?.tPosID}
                        onChange={() => { }}
                        onChangeGetDetailed={(e) => { this.setState({ modalCreateEdit: { ...this.state.modalCreateEdit, tPosID: e.code, tPosName: e.name } }) }}
                    />
                </Form.Item>
            </GenericModal>
            <GenericModal
                visible={this.state.filtersModal}
                onCancel={() => { this.setState({ filtersModal: false }) }}
                title={gt(22468)}
                width={600}
                footer={[
                    <Button key="back" style={{ marginLeft: 5 }} onClick={() => { this.setState({ filtersModal: false }) }}>{gt(22469)}</Button>,
                    <Button key="back" style={{ marginLeft: 5 }} onClick={() => { this.setState({ filters: { _posList: '', _langId: null } }) }}>{gt(22470)}</Button>,
                    <Button key="create" type="primary" onClick={() => {
                        this.setState({ filtersModal: false }, () => {
                            this.props.dataActions.genericDataSetFilter(
                                this.id, this.props.user.companyCode, this.props.user.token, this.state.filters, this.api.get);
                        })
                    }}>{gt(22471)}</Button>,
                ]}
            >
                <Form.Item label={gt(22472)}>
                    <GenericSelector
                        {...this.props} {...this.selectors[0]} 
                        addFirstRow={{ code: "-", name: gt(22474) }}
                        value={this.state.filters._langId}
                        onChange={(e) => { this.setState({ filters: { ...this.state.filters, _langId: e } }) }}
                    />
                </Form.Item>
                <Form.Item label={gt(22473)}>
                    <GenericSelectorPosStorages
                        {...this.props} multi 
                        value={this.state.filters._posList ? this.state.filters._posList.split(",") : []}
                        onChange={(e) => { this.setState({ filters: { ...this.state.filters, _posList: e ? e.join(",") : "" } }) }}
                    />
                </Form.Item>
            </GenericModal>
        </div>)
    }

}

export default SelfServiceTexts;